import * as Yup from "yup";

export const SaveFileSchema = Yup.object({
  file: Yup.mixed().required("Campo requerido"),
});
